import React, { useEffect, useState } from 'react'
import { Alert, Box, IconButton, Slide, Paper } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import api from '../../config/api'
import { isAuthenticated } from '../../config/config'

export default function NotificationStack() {
  const [notifications, setNotifications] = useState([])

  // Подгружаем "оповещения" с фейкового API
  useEffect(() => {
    if (isAuthenticated()) {
      const load = async () => {
        const response = await api.get('/API_FRONT/user/notifications/get-list')
        const data = response?.data
        setNotifications(data)

        data.forEach((n) => {
          setTimeout(() => removeNotification(n.id), 5000)
        })
      }
      load()
    }
  }, [])

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id))
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 1400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 1,
      }}
    >
      {notifications.map((notification) => (
        <Slide
          key={notification.id}
          direction="left"
          in
          mountOnEnter
          unmountOnExit
        >
          <Paper elevation={4}>
            <Alert
              severity={notification.severity}
              variant="outlined"
              action={
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={() => removeNotification(notification.id)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
              sx={{ minWidth: 300 }}
            >
              {notification.message}
            </Alert>
          </Paper>
        </Slide>
      ))}
    </Box>
  )
}
